import React, { useEffect, useState } from "react";
import { getDocs, collection, query, where, DocumentData } from "firebase/firestore";
import { db } from "../../firebase";
import { Table, Text } from "@mantine/core";

interface FirestoreOptionsPreviewProps {
  firestoreDocId: string;
  companyId: string;
}

export default function FirestoreOptionsPreview({ firestoreDocId, companyId }: FirestoreOptionsPreviewProps) {
  const [docData, setDocData] = useState<DocumentData | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!firestoreDocId || !companyId) return;
    setLoading(true);
    const fetchDoc = async () => {
      const q = query(
        collection(db, "flexFormSelectOptions"),
        where("companyId", "==", companyId)
      );
      const snapshot = await getDocs(q);
      const matchedDoc = snapshot.docs.find((d) => d.id === firestoreDocId)?.data();
      setDocData(matchedDoc || null);
      setLoading(false);
    };
    fetchDoc();
  }, [firestoreDocId, companyId]);
  if (loading)
    return (
      <Text size="xs" color="dimmed">
        Loading options…
      </Text>
    );
  if (!docData)
    return (
      <Text size="xs" color="red">
        No options set found for this ID.
      </Text>
    );
  return (
    <div style={{ marginBottom: 12, border: "1px solid #e0e0e0", padding: 8, borderRadius: 4 }}>
      <Text size="sm" weight={500} mb={12} style={{display: 'flex', alignItems: 'center'}}>
        Selected Options Set: {"\u00A0"}<Text underline weight={500}>{docData.name}</Text>
      </Text>
      <Table>
        <tbody>
          <tr>
            <td><Text weight={500}>Label</Text></td>
            <td><Text weight={500}>Value</Text></td>
          </tr>
          {(docData.options as Array<{ label: string; value: string }> | undefined)?.slice(0, 3).map((opt, idx) => (
            <tr key={idx}>
              <td>{opt.label}</td>
              <td>{opt.value}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={2}>
              ... (showing first 3 of {(docData.options as any[])?.length || 0} options)
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
